import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { QueryKeyConfig } from '../../api/api-helper';
import { useLoadData } from '../../hooks/useLoadData';
import { ApiResponse } from '../../models/api-response';
import { LoadingIndicator } from '../loading-indicator.component';
import { useEffect, useState } from 'react';
import { AutoCompleteSelect } from '../autocomplete-select.component';
import { FormError } from './hook-form-error';

interface AutoCompleteSelectFieldDynamicProps {
  dataItems?: any[];
  getQueryKeyConfig?: (inputData: any, getValues: any) => QueryKeyConfig;
  label: string;
  name: string;
  watchKeys?: string[];
  size?: number;
  onChange?: any;
  disabled?: boolean;
  optionsValueKey: string;
  optionsLabelKey: string;
  required?: boolean;
  clearIcon?: boolean;
  parentLoading?: boolean;
}

const mergeDataItems = (data1: any[], data2: any[], key: string) => {
  const dataArray1 = Array.isArray(data1) ? data1 : [];
  const dataArray2 = Array.isArray(data2) ? data2 : [];
  const result = dataArray1.filter((d) => !dataArray2.some((d2) => d2[key] === d[key]));
  return [...result, ...dataArray2];
};

export const FormAutoCompleteSelectDynamic = ({
  name,
  label,
  size,
  watchKeys,
  dataItems,
  onChange,
  disabled,
  optionsValueKey,
  optionsLabelKey,
  getQueryKeyConfig,
  clearIcon,
  parentLoading
}: AutoCompleteSelectFieldDynamicProps): any => {
  const {
    control,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();
  const [completeData, setCompleteData] = useState<any[]>([]);

  useWatch({
    name: watchKeys || [],
  });

  const query = getQueryKeyConfig?.(
    watchKeys?.reduce((acc: any, key) => ({ ...acc, [key]: getValues(key) }), {}),
    getValues
  );

  // if (name === 'customer') {
  //   console.log(errors);
  // }

  const { data, isLoading, isFetching } = useLoadData<ApiResponse<any[]>>(query, !!query);

  useEffect(() => {
    const mergedData = mergeDataItems(data?.data ?? [], dataItems ?? [], optionsValueKey);
    setCompleteData(mergedData);
    const currentValue = getValues(name);
    if (mergedData?.length > 0 && currentValue && currentValue[optionsValueKey] && !currentValue[optionsLabelKey]) {
      const newValue = mergedData?.find((d) => d[optionsValueKey] === currentValue[optionsValueKey]);
      setValue(name, { ...newValue });
    }
  }, [data, dataItems]);

  const handleChange = (value: any) => {
    onChange(value);
  };

  return (
    <>
      <LoadingIndicator isLoading={isLoading || isFetching || parentLoading} />
      <Controller
        control={control}
        name={name}
        render={({ field }) => {
          if (completeData.length > 0) {
            return (
              <AutoCompleteSelect
                options={completeData}
                label={label}
                size={size}
                clearIcon={clearIcon}
                disabled={disabled || isLoading || isFetching}
                onChange={(value: any) => {
                  field.onChange(value);
                  handleChange(value);
                }}
                selectedValue={field.value}
                optionsLabelKey={optionsLabelKey}
                optionsValueKey={optionsValueKey}
              />
            );
          }
          return (
            <AutoCompleteSelect
              options={completeData}
              label={label}
              size={size}
              disabled={disabled}
              clearIcon={clearIcon}
              onChange={(value: any) => {
                field.onChange(value);
                handleChange(value);
              }}
              selectedValue={field.value}
              optionsLabelKey={optionsLabelKey}
              optionsValueKey={optionsValueKey}
            />
          );
        }}
      />
      <FormError name={name} />
    </>
  );
};

FormAutoCompleteSelectDynamic.defaultProps = {
  optionsValueKey: 'id',
  defaultItemKey: 'name',
  onChange: () => {
    return;
  },
};
